import { type ComponentProps } from "react"
import { Tooltip } from "@octopus-energy/coral/atoms"
import { styled } from "@octopus-energy/coral-design/jsx"

const StyledTooltipWrapper = styled("span", {
    base: {
        "& [data-part='tooltip-content']": {
            textAlign: "left",
            whiteSpace: "pre-line",
        },
    },
})

type LeftAlignedTooltipProps = ComponentProps<typeof Tooltip>

export function LeftAlignedTooltip(props: LeftAlignedTooltipProps) {
    return (
        <StyledTooltipWrapper>
            <Tooltip {...props} />
        </StyledTooltipWrapper>
    )
}
